import { Component } from '@ecs/Component'
import { TransformData } from './Transform'
import { PlayerController } from './PlayerController'
import { OverlayInterface } from './UI/OverlayInterface'


export abstract class SpecificController extends Component {
    name!: String

    playerController!: PlayerController
    cameraDistance = 0
    interupted = false
    targetTransform!: TransformData
    exitBtnOverlay!: OverlayInterface
    isRemoving = false;

    setup(_data: any) {
        if (!(_data.playerController instanceof PlayerController)) {
            _data.playerController = this.scene.mainCamera!.gameObject.getComponent(PlayerController)!
        }
        this.name = this.constructor.name
        if (_data.name) this.name = _data.name
        this.playerController = _data.playerController
        this.playerController.addSubController(this)
        this.targetTransform = new TransformData().copy(this.transform.transformData)

        this.exitBtnOverlay = this.gameObject.addComponent(OverlayInterface, {
            innerHTML: `
            <input type="button" value="Quitter" id="exitButton" style="position: absolute; top: 20px; right: 20px; font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5); border: none; border-radius: 10px; width: 200px; height: 50px; cursor: pointer; pointer-events: auto;"/>
            `})
        this.exitBtnOverlay.element.querySelector('#exitButton')?.addEventListener('click', () => {
            this.isRemoving = true
        });
    }
    start() {
    }
    exitController() {
        if (this.playerController && this.playerController.specificControllers.length > 1) {
            this.remove()
        }
    }
    updateActions(_dt: number): void {

    }
    render(_dt: number): void {
        this.exitBtnOverlay.enabled = !this.interupted
        if (this.isRemoving) {
            this.gameObject.removeComponent(this)
        }
    }
    onDestroy(): void {
        this.playerController.removeController(this)
        this.gameObject.removeComponent(this.exitBtnOverlay)
    }
}